<form (ngSubmit)="submitToken()">
  <h2 class="tokenField__title">{{ 'shared.confirmYourEmailAddress' | translate }}</h2>
  <p class="tokenField__excerpt" [innerHTML]="'shared.weSentEmailWithConfirmationCode' | translate: { email: email }"></p>

  <p class="tokenField__alert warning" *ngIf="isOutlookEmail(email)"><i class="tokenField__alert-icon"></i> <span [innerHTML]="'shared.ifEmailNotVisibleAddToContacts' | translate"></span></p>

  <label class="field__holder" [appFormControlWrap]="otp">
    <input type="tel" class="field" [formControl]="otp" name="otp" autocomplete="one-time-code" maxlength="6" appOnlyNumbers required />
    <span class="field__placeholder">{{ 'auth.confirmCode' | translate }}</span>
  </label>

  <p class="tokenField__alert" *ngIf="isInvalidToken"><i class="tokenField__alert-icon"></i> {{ 'shared.oopsIncorrectCode' | translate }}</p>
  <div class="tokenField__resend">
    <span class="tokenField__resend-text">{{ 'shared.didNotReceiveCode' | translate }}</span>
    <button type="button" class="tokenField__resend-button btn btn-link" (click)="sendEmailConfirmation()" [disabled]="isVerifyingToken">
      {{ 'shared.clickHereToResend' | translate }}
    </button>
  </div>

  <ng-content></ng-content>
</form>
